import * as FIELD_NAME from 'constant/form-item-names'
import * as NUMBER from 'constant/number'
import { connect } from 'react-redux'
import { Form } from 'antd'
import React from 'react'
import PropTypes from 'prop-types'
import UserTypeSelect from 'view/component/form-items/user-type-select'
import _ from 'lodash'

const ArticleUserTypeSelect = ({ categories }) => {
  const handleUpdate = (prevValues, currentValues) => {
    return prevValues.category_uuid !== currentValues.category_uuid || prevValues.special !== currentValues.special
  }
  return (
    <Form.Item
      noStyle
      shouldUpdate={handleUpdate}
    >
      {({ getFieldValue }) => {
        const categoryUuids = getFieldValue(FIELD_NAME.CATEGORY_UUID)
        const special = getFieldValue(FIELD_NAME.SPECIAL)
        if (!categoryUuids?.length) {
          return
        }

        const subCategories = getSubCats(categories)
        const userTypes =
          subCategories
            .filter(({ uuid }) => categoryUuids.includes(uuid))
            .reduce((result, subCategory) => [
              ...result,
              ...subCategory.user_types
            ], [])
        return userTypes?.length && !special
          ? (
            <UserTypeSelect userTypes={_.uniqBy(userTypes, 'uuid')} />
          )
          : null
      }}
    </Form.Item>
  )
}

const getSubCats = (categories) =>
  categories.map((category) => category.sub_categories.length === NUMBER.ZERO ? [category] : category.sub_categories)
    .flat(NUMBER.TWO)

ArticleUserTypeSelect.propTypes = {
  categories: PropTypes.array
}

const mapStateToProps = (state) => ({
  categories: state.category.categories
})

export default connect(mapStateToProps)(ArticleUserTypeSelect)
